import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function Results() {
  const { ref, isVisible } = useScrollAnimation();

  const results = [
    { icon: 'ri-line-chart-line', text: 'Better staff performance' },
    { icon: 'ri-user-heart-line', text: 'Reduced turnover' },
    { icon: 'ri-shield-check-line', text: 'Stronger inspections' },
    { icon: 'ri-file-check-line', text: 'Cleaner documentation' },
    { icon: 'ri-refresh-line', text: 'More consistency' },
    { icon: 'ri-building-line', text: 'A calmer building' },
    { icon: 'ri-heart-line', text: 'Happier residents and families' },
    { icon: 'ri-time-line', text: 'More time for leadership' }
  ];

  return (
    <section ref={ref as React.RefObject<HTMLElement>} className="py-20 bg-teal-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`text-center mb-16 ${isVisible ? 'opacity-100 animate-fade-in-up' : 'opacity-0'}`}>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            The Results You'll See
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {results.map((result, index) => (
            <div 
              key={index}
              className={`bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20 hover:bg-white/20 transition-all ${
                isVisible ? 'opacity-100 animate-scale-in' : 'opacity-0'
              }`}
              style={{ animationDelay: `${index * 0.08 + 0.2}s` }}
            >
              <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full mb-4 mx-auto">
                <i className={`${result.icon} text-2xl text-white`}></i>
              </div>
              <p className="text-white text-center font-medium">
                {result.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
